// pages/limousine/index.jsx
/* eslint-disable @next/next/no-img-element */
import Image from "next/image";
import Header3 from "../../components/header/header-rslhome";
import Seo from "../../components/common/Seo";
import CtaButton from "../../components/buttonWithArrow";
import PickYourCarGrid from "../../components/Investments/PickYourCarToInvest";
import RoiInvestorBenefits from "../../components/Investments/RoiInvestorBenefits";
import { CAR_RENTAL_PAGE } from "../../data/carRental";
import CommunicationChannel from "../../components/Investments/CommunicationChannel";
import Footer3 from "../../components/footer/footer-new";
import InvestmentSimulatorFlow from "../../components/Investments/CostCalculatoreLimousine";
import InvestNow from "../../components/investNow";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
// import fleetData from "../../data/fleets.json";
import { getLimousineFleetList, carRentalInvestNow } from "../../redux/slices/investments"
import { useDispatch, useSelector } from '../../redux/store';
import AfterFormSubmit from "../../components/investNow/AfterFormSubmit";
import { bannerHeight } from "../../utils/bannerHeight";
import { fetchSeoByPage } from "../../lib/seoHelper";

const INITIAL_STATE = {
  vehicle: '',
  initial: '',
  monthly: '',
  month: ''
}

export default function CarRental({ meta }) {
  const HEADER_OFFSET = 88;
  const dispatch = useDispatch();
  const { fleetsRes, carRentalEnquiryRes } = useSelector(
    state => state.investment
  );
  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const y = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({ top: y, behavior: "smooth" });
  };
  const [enquiryOpen, setEnquiryOpen] = useState(false)
  const [statusMessage, setStatusMessage] = useState('');
  const [status, setStatus] = useState(null);
  const [loader, setLoader] = useState(false)
  const [loading, setLoading] = useState(true);
  const [fleetData, setFleetData] = useState([]);
  const [priceData, setPriceData] = useState([]);
  const [formLoader, setFormLoader] = useState(false);
  const [step, setStep] = useState(1);
  const [amount, setAmount] = useState(null);
  const [bannerImage, setBannerImage] = useState(null);
  // const [selectedVehicle, setSelectedVehicle] = useState('')
  // const [contact, setContact] = useState(INITIAL_STATE)
  const [openEnquire, setOpenEnquire] = useState(false)
  const [costCalculateOpen, setCostCalculateOpen] = useState(false);
  const [values, setValues] = useState({
    name: "",
    email: "",
    phone: "",
    countryCode: "971",
    "itemId": "",
    formType: 2,
    itemInfo: null
  })

  const handleCostCalculateOpen = () => {
    setCostCalculateOpen(true);
  }

  const handleClose = () => {
    setCostCalculateOpen(false);

    setValues({
      name: "",
      email: "",
      phone: "",
      countryCode: "971",
      "itemId": "",
      formType: 2,
      itemInfo: null
    });
    setStep(1);
    setAmount(null);
  }

  const handleCostCalculate = (val) => {
    setFormLoader(true);
    const obj1 = {
      ...val,
      currency: typeof window !== "undefined"
        ? JSON.parse(sessionStorage.getItem("currency") || "{}")?.value || "aed"
        : "aed"
    }
    dispatch(carRentalInvestNow(obj1));
  }

  const handleClickOpen = () => {
    setEnquiryOpen(true)
  }

  useEffect(() => {
    if (carRentalEnquiryRes && formLoader) {
      setFormLoader(false)
      if (carRentalEnquiryRes.status === 1) {
        handleClickOpen()
        handleClose();
        setStatusMessage('')
        setStatus(carRentalEnquiryRes.status);
      } else {
        handleClickOpen()
        setStatus(-1)
        setStatusMessage(carRentalEnquiryRes.message || `We’re sorry! Something went wrong. Please try again in a few moments.`)
      }
    }
  }, [carRentalEnquiryRes])

  const onClose = () => {
    if (statusMessage === '' && status === 1) {
      // setOpen(false);
      handleClose();
    }
    setEnquiryOpen(false)
  }

  const handleOpenEnquire = () => setOpenEnquire(true)
  const handleCloseEnquire = () => setOpenEnquire(false)

  const handleEnquirySubmit = (value) => {
    setLoader(true);
    const obj = {
      ...value,
      formType: 1,
      currency: typeof window !== "undefined"
        ? JSON.parse(sessionStorage.getItem("currency") || "{}")?.value || "aed"
        : "aed"
    }
    dispatch(carRentalInvestNow(obj))
  }

  useEffect(() => {
    setLoading(true);
    dispatch(getLimousineFleetList("car"));
  }, [])

  useEffect(() => {
    if (fleetsRes) {
      setLoading(false);
      if (fleetsRes?.status === 1) {
        setFleetData(fleetsRes?.responseData ?? []);
        setPriceData(fleetsRes?.priceData?.priceList ?? []);
        setBannerImage(fleetsRes?.carBannerImage || null);
      } else {
        setFleetData([]);
        setBannerImage(null);
      }
    }
  }, [fleetsRes])

  return (
    <>
      <Seo meta={meta} />
      <Header3 bgColor="#EBEBEB" borderColor="#DFDFDF" />

      <section
        className="hero"
        style={{
          position: "relative",
          width: "100%",
          height: bannerHeight(),
          overflow: "hidden",
        }}
      >
        {/* Fixed background layer */}
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: bannerHeight(),
            zIndex: 0,
          }}
        >
          {/* BG image */}
          <Image
            // src="/img/investments/carRental/banner.svg"
            src={bannerImage ? `${process.env.IMAGE_BASE_URL}/${bannerImage}` : "/img/investments/carRental/banner.svg"}
            alt="limousine"
            fill
            priority
            sizes="100vw"
            style={{ objectFit: "cover" }}
          />
          {/* Gradient overlay */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              top: 0,
              background: "linear-gradient(to top, #00000082 0%, rgba(0, 0, 0, 0) 20%)",
              zIndex: 1,
              pointerEvents: "none",
            }}
          />
          {/* dark gradient overlay */}
          {/* <div className="overlay" aria-hidden="true" /> */}

          {/* content */}
          <div className="content">
            <h1 className="title jura">
              <span className="scribble-wrap">
                <span className="scribble-text">Invest</span>
                {/* teal hand-drawn oval */}
                <img
                  src="/img/header/Oval.svg"
                  alt=""
                  className="scribble"
                />
              </span>{" "}
              in Car Rental
            </h1>

            <div className="cta">
              <CtaButton label="Check Car" onClick={() => scrollToId("fleet")} endIconSrc="/img/header/VectorDown.svg" />
              {/* <CtaButton cta={{ label: "Check Fleet", href: "#fleet" }} endIconSrc="/img/header/VectorDown.svg" /> */}
            </div>
          </div>
        </div>
      </section>
      <Box
        id="fleet"
        sx={{
          position: "relative",
          zIndex: 3,
          pt: `${bannerHeight()}px`,
        }}
      >
        <Box id="fleet" sx={{ scrollMarginTop: { xs: '80px', md: '96px' }, background: "#fff" }}>
          <PickYourCarGrid data={{
            ...CAR_RENTAL_PAGE?.carToInvest,
            carData: fleetData
          }} name="Car Rental" loader={loading} endIconSrc="/img/header/VectorDown.svg" onDown="investmentGuide" costCalculate={handleCostCalculateOpen} />
        </Box>
        <Box id="investmentGuide" sx={{ scrollMarginTop: { xs: '80px', md: '96px' } }}>
          <RoiInvestorBenefits data={CAR_RENTAL_PAGE?.roiInvestorBenefits} onClick={() => handleOpenEnquire()} />
        </Box>
        <Box sx={{ background: "#fff" }}>
          <CommunicationChannel data={CAR_RENTAL_PAGE.communicationChannel} />
        </Box>
        <Footer3 bgcolor="#f8f8f8" />
      </Box>
      <style jsx>{`
        :global(html, body) {
         scroll-behavior: smooth;
          overflow-x: hidden;
        }

        .hero {
          position: relative;
          width: 100%;
          // min-height: clamp(60vh, 72vh, 80vh);
          min-height: ${bannerHeight()};
          border-radius: 0;
          isolation: isolate; /* ensure overlay/contents stack correctly */
        }

        .overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
              to top,
              rgba(0, 0, 0, 0.78) 0%,
              rgba(0, 0, 0, 0.55) 35%,
              rgba(0, 0, 0, 0.08) 70%,
              rgba(0, 0, 0, 0) 100%
            ),
            radial-gradient(60% 60% at 50% 50%, rgba(0, 0, 0, 0.25), transparent 70%);
          z-index: 1;
          pointer-events: none;
        }

        .content {
          position: absolute;
          inset: 0;
          z-index: 2;
          display: grid;
          place-items: end center;
          padding: clamp(16px, 4vw, 28px);
          /* push content slightly above bottom like the mock */
          align-content: end;
          gap: clamp(16px, 3vh, 28px);
          padding-bottom: clamp(36px, 10vh, 40px);
          text-align: center;
        }

        .title {
          color: #ffffff;
          font-weight: 600;
          letter-spacing: 0.02em;
          line-height: 1.1;
          margin: 0;
          /* responsive font like the design */
          font-size: clamp(28px, 6.5vw, 52px);
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
        }

        .scribble-wrap {
          position: relative;
          display: inline-block;
        }

        .scribble-text {
          position: relative;
          z-index: 2;
        }

        .scribble {
          position: absolute;
          z-index: 1;
          left: -0.35em;
          top: 5px;
          width: clamp(7.5em, 14vw, 13em); /* scales with font size */
          height: auto;
          transform: rotate(-4deg);
          pointer-events: none;
          filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.25));
          opacity: 0.95;
        }

        .cta {
          display: flex;
          justify-content: center;
        }

        /* Button polish to match mock (rounded pill + subtle shadow) */
        :global(.cta button),
        :global(.cta a) {
          border-radius: 999px !important;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
        }

        /* Responsive tweaks */
        @media (max-width: 768px) {
          .content {
            padding-bottom: 48px;
          }
          .scribble {
            left: -0.3em;
            top: 10px;
          }
        }

        @media (max-width: 420px) {
          .title {
            line-height: 1.08;
            letter-spacing: 0.01em;
          }
          .scribble {
            width: 8.8em;
          }
        }
      `}</style>

      <InvestmentSimulatorFlow
        open={costCalculateOpen}
        priceData={priceData}
        onClose={() => handleClose()}
        onInvest={(p) => handleCostCalculate(p)}
        setValues={setValues}
        values={values}
        formLoader={formLoader}
        setStep={setStep}
        step={step}
        amount={amount}
        setAmount={setAmount}
        url="car"
      />

      {/* <InvestNow
        open={openEnquire}
        setOpen={setOpenEnquire}
        onClose={handleCloseEnquire}
        fleetCard={fleetData}
      contact={contact}
      setContact={setContact}
      selectedVehicle={selectedVehicle}
      setSelectedVehicle={setSelectedVehicle}
      /> */}
      <AfterFormSubmit open={enquiryOpen} status={status} message={statusMessage} onClose={onClose} Catalog={statusMessage === ""} />
      <InvestNow
        open={openEnquire}
        onClose={handleCloseEnquire}
        fleetCard={fleetData}
        handleSubmit={handleEnquirySubmit}
        loader={loader}
        setLoader={setLoader}
        labels={["Name", "Email", "Phone", "Select Vehicle", "Passport Copy"]}
        apiResponse={carRentalEnquiryRes}
      />

    </>
  );
}

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}